import React, { useContext, useEffect, useState } from 'react';
import { UserContext } from '../UserContext';
import { getUser, deleteRecipe, getFavourites } from '../api';
import { Link } from 'react-router-dom';
import { Box, Typography, Button, List, ListItem } from '@mui/material';

const ProfilePage = () => {
  const { user, setUser } = useContext(UserContext);
  const [recipes, setRecipes] = useState([]);
  const [favourites, setFavourites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userData = await getUser();
        setUser(userData.user);
        setRecipes(userData.recipes);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    const fetchFavourites = async () => {
      try {
        const data = await getFavourites();
        setFavourites(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    
    fetchFavourites();

    fetchUserData();
  }, [setUser]);

  const handleDelete = async (recipeId) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cette recette ?')) {
      try {
        await deleteRecipe(recipeId);
        setRecipes(recipes.filter((recipe) => recipe.id !== recipeId));
        alert('Recette supprimée avec succès !');
      } catch (err) {
        alert(`Erreur : ${err.message}`);
      }
    }
  };

  if (loading) {
    return <p>Chargement...</p>;
  }

  if (error) {
    return <p style={{ color: 'red' }}>Erreur : {error}</p>;
  }

  return (
<Box sx={{ padding: 3 }}>
      <Typography variant="h3" gutterBottom>
        Mon Profil
      </Typography>
      
      <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
        <span style={{ fontWeight: 'bold' }}>Nom :</span> {user.name}
      </Typography>
      <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
        <span style={{ fontWeight: 'bold' }}>Email :</span> {user.email}
      </Typography>
      
      <Typography variant="h4" sx={{ mt: 3 }}>
        Mes Recettes
      </Typography>
      {Array.isArray(recipes) && recipes.length > 0 ? (
        <List sx={{ marginTop: 2 }}>
          {recipes.map((recipe) => (
            <ListItem key={recipe.id} sx={{ display: 'flex', flexDirection: 'column', mb: 2, border: '1px solid #ddd', borderRadius: '8px', padding: 2 }}>
              <Typography variant="h6">{recipe.name}</Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {recipe.description}
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                <span style={{ fontWeight: 'bold' }}>Likes :</span> {recipe.likeCount}
              </Typography>

              <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
                <Button component={Link} to={`/recipes/${recipe.id}`} variant="outlined" color="primary" sx={{ flex: 1 }}>
                  Voir plus
                </Button>
                <Button component={Link} to={`/recipes/edit/${recipe.id}`} variant="contained" color="primary" sx={{ flex: 1 }}>
                  Modifier
                </Button>
                <Button onClick={() => handleDelete(recipe.id)} variant="contained" color="error" sx={{ flex: 1 }}>
                  Supprimer
                </Button>
              </Box>
            </ListItem>
          ))}
        </List>
      ) : (
        <Typography variant="body1">Vous n'avez pas encore créé de recettes.</Typography>
      )}
      
      <Typography variant="h4" sx={{ mt: 3 }}>
        Mes Favoris
      </Typography>
      {favourites.length > 0 ? (
        <List sx={{ marginTop: 2 }}>
          {favourites.map((recipe) => (
            <ListItem key={recipe.id} sx={{ display: 'flex', flexDirection: 'column', mb: 2, border: '1px solid #ddd', borderRadius: '8px', padding: 2 }}>
              <Typography variant="h6">{recipe.name}</Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {recipe.description}
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                <span style={{ fontWeight: 'bold' }}>Likes :</span> {recipe.likeCount}
              </Typography>
              <Button component={Link} to={`/recipes/${recipe.id}`} variant="outlined" color="primary" sx={{ mt: 2 }}>
                Voir plus
              </Button>
            </ListItem>
          ))}
        </List>
      ) : (
        <Typography variant="body1">Vous n'avez pas encore ajouté de recettes à vos favoris.</Typography>
      )}
    </Box>
  );
};

export default ProfilePage;